/* GoClove PLP — Cart & Drawers */
(function () {
  if (window.__GOC_PLP_CART__) return;
  window.__GOC_PLP_CART__ = true;

  window.__GOC_PLP__ = window.__GOC_PLP__ || {};
  const GOC = window.__GOC_PLP__;

  function setDrawer(root, key, open) {
    const { SELECTORS, qs } = GOC;
    const d = qs(root, `${SELECTORS.drawer}[data-goc-drawer="${key}"]`)
           || document.querySelector(`${SELECTORS.drawer}[data-goc-drawer="${key}"]`);
    if (!d) return;

    d.hidden = !open;
    if (open) {
      d.dataset.open = "1";
      document.documentElement.style.overflow = "hidden";
      const close = qs(d, SELECTORS.closeBtn);
      if (close) close.focus();
    } else {
      delete d.dataset.open;
      document.documentElement.style.overflow = "";
    }
  }

  function closeAnyDrawer(root) {
    const { SELECTORS, qsa } = GOC;
    const inRoot = Array.from(qsa(root, SELECTORS.drawer));
    const teleported = Array.from(document.querySelectorAll(SELECTORS.drawer))
      .filter(d => d.__gocRoot === root && !root.contains(d));
    [...inRoot, ...teleported].forEach((d) => { d.hidden = true; delete d.dataset.open; });
    document.documentElement.style.overflow = "";
  }

  function bindGlobalDrawersOnce() {
    if (window.__GOC_DRAWERS_BOUND__) return;
    window.__GOC_DRAWERS_BOUND__ = true;
    const { SELECTORS } = GOC;

    document.addEventListener("click", (e) => {
      const openBtn = e.target.closest(SELECTORS.openBtn);
      if (!openBtn) return;
      const key = openBtn.getAttribute("data-goc-open");
      if (!key) return;
      e.preventDefault();
      const root = openBtn.closest(SELECTORS.section) || document.querySelector(SELECTORS.section);
      if (!root) return;
      closeAnyDrawer(root);
      setDrawer(root, key, true);
    }, true);

    document.addEventListener("click", (e) => {
      const closeBtn = e.target.closest(SELECTORS.closeBtn);
      if (!closeBtn) return;
      const root = closeBtn.closest(SELECTORS.section) || document.querySelector(SELECTORS.section);
      if (!root) return;
      e.preventDefault();
      closeAnyDrawer(root);
    }, true);

    document.addEventListener("click", (e) => {
      const overlay = e.target.closest(".gocplp__overlay");
      if (!overlay) return;
      const root = overlay.closest(SELECTORS.section) || document.querySelector(SELECTORS.section);
      if (!root) return;
      e.preventDefault();
      closeAnyDrawer(root);
    }, true);
  }

  async function addToCart(variantId, qty) {
    // B2C PREORDER DATE CUTOFF: never allow adding a variant whose pre-order date is too far out.
    const blockedMap = window.GOCBlockedVariants || {};
    if (blockedMap[variantId] || blockedMap[String(variantId)] || blockedMap[Number(variantId)]) {
      throw new Error("Pre-order not available: ship date too far out");
    }
    const payload = { items: [{ id: Number(variantId), quantity: Number(qty || 1) }] };
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error("Add to cart failed");
    return res.json();
  }

  function openCartDrawerBestEffort() {
    try {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:open"));
    } catch (e) {}

    const drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.open === "function") { drawer.open(); return; }
    const toggle = document.querySelector("[data-cart-drawer-toggle], a[href='/cart'], a[href$='/cart']");
    if (toggle && typeof toggle.click === "function") toggle.click();
  }

  Object.assign(GOC, {
    setDrawer, closeAnyDrawer, bindGlobalDrawersOnce,
    addToCart, openCartDrawerBestEffort
  });
})();
